const handleCloseDialogModalEquipService = {
  confirm: 'Su información no guardada se perderá.',
  title: '¿Salir?',
}

export default handleCloseDialogModalEquipService;
